import React from 'react';
import factory from 'components/Icons/factory';

export const Comment = factory(
  'Comment',
  <path d="M116 12H12C6.5 12 2 16.5 2 22v60c0 5.5 4.5 10 10 10h10.4v28.5c0 3.2 2.2 4.5 5 2.6L60.9 92H116c5.5 0 10-4.5 10-10V22c0-5.5-4.5-10-10-10z" />
);

export default Comment;
